import styles from './NoOpportunitySelected.module.css'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgDiscoverUrl from '@/assets/misc/img_discover.svg'
import UnavailableIllustration from '@/components/SpotIllustration/UnavailableIllustration'

interface NoOpportunitySelectedProps {
  corporateMode: boolean
}

export function NoOpportunitySelected({
  corporateMode,
}: NoOpportunitySelectedProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <EmptyState size="sm">
          {!corporateMode && (
            <EmptyStateIllustration
              alt="Woman with binoculars"
              src={imgDiscoverUrl}
              illustration={byDesign(undefined, UnavailableIllustration)}
            />
          )}
          <EmptyStateTitle>
            Having trouble spotting opportunity details?
          </EmptyStateTitle>
          <EmptyStateDescription>
            Simply select an opportunity card on the left to discover more
            details around the work required.
          </EmptyStateDescription>
        </EmptyState>
      </div>
    </div>
  )
}
